module.exports = __webpack_public_path__ + "img/staple_stripe.01847be4.jpg";